export function stringNumber(number: number): string {
  return number < 10 ? `0${number}` : number.toString();
}

export function stringNumberDate(number: number): string {
  return number === 1 ? '1er': number.toString();
}
